export const ACCEPTED = "accepted";
export const ACCEPTING = "accepting";
export const FETCHED = "fetched";
export const FETCHING = "fetching";
export const LOCKED = "locked";
export const UNFETCHED = "unfetched";

export const ACCEPT = "VV.ACCEPT";
